import React from "react";
import { Inner } from "./styles";
import { Input, InputNumber } from "antd";

export default function ProductWeight({ product, onChange }) {
	const handleChange = (e) => {
		// if (e.target.value <= 0) {
		// 	e.target.value = 0;
		// 	e.target.setSelectionRange(0, 0);
		// 	e.target.focus();
		// 	e.target.select();
		// }
		// if (e.target.value >= 1) e.target.value = 1;
		// const onlyPositiveInteger = /^[0-9]*\.?[0-9]{0,2}$/;
		// if (onlyPositiveInteger.test(e.target.value))
		onChange({ index: product.index, value: e });
	};

	const handleFocus = (event) => event.target.select();

	return (
		<Inner>
			<InputNumber
				min={0.0}
				max={1.0}
				step={0.1}
				value={product.baseBoost}
				onChange={handleChange}
				onFocus={handleFocus}
			/>
		</Inner>
	);
}
